module.exports = __webpack_public_path__ + "static/media/6.797851ee.jpg";